// Module counter: stays monotonic and comparable with server-minted Date.now()
// versions. If the module was idle long enough that wall clock passed the last
// counter, the next call jumps to Date.now() rather than issuing a stale value
// that would be treated as older than any version the server already stamped.
// Client-only: a module counter on the server would be shared across requests.
let counter = 0;

export function nextCartVersion(): number {
	counter = Math.max(counter + 1, Date.now());
	return counter;
}
